import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Constants } from '../models/constants.model';
import { BaseClient } from './base-client.service';
import { FaqListResponse } from '../models/faq/faq-list-response';
import { Faq } from '../models/faq/faq';

@Injectable()
export class FaqClient extends BaseClient {    
    public static readonly BASE_ENDPOINT = Constants.API_BASE_URL + '/faqs';
    
    public list(): Observable<FaqListResponse> {
        return this.authService.getToken().pipe(switchMap((token) => {            
            return this.http.get<FaqListResponse>(FaqClient.BASE_ENDPOINT, {headers: this.getHeaders(token)});
        }));
    }

    public show(id: string): Observable<Faq> {
        return this.authService.getToken().pipe(switchMap((token) => {            
            return this.http.get<Faq>(FaqClient.BASE_ENDPOINT + '/' + id, {headers: this.getHeaders(token)});
        }));
    }

    public store(formData: FormData): Observable<Faq> {        
        return this.authService.getToken().pipe(switchMap((token) => {            
            return this.http.post<Faq>(FaqClient.BASE_ENDPOINT, formData, {headers: this.getHeaders(token, false)});
        }));
    }

    public update(id, formData: FormData): Observable<Faq> {
        return this.authService.getToken().pipe(switchMap((token) => {            
            return this.http.post<Faq>(FaqClient.BASE_ENDPOINT + '/' + id, formData, {headers: this.getHeaders(token, false)});
        }));
    }

    public delete(id): Observable<any> {        
        return this.authService.getToken().pipe(switchMap((token) => {            
            return this.http.delete<any>(FaqClient.BASE_ENDPOINT + '/' + id, {headers: this.getHeaders(token)});
        }));
    }
}